export function convertColor(hex, percent) {
  const num = parseInt(hex.replace("#", ""), 16)
  const r = Math.min(255, Math.max(0, (num >> 16) + (255 * percent) / 100))
  const g = Math.min(
    255,
    Math.max(0, ((num >> 8) & 0x00ff) + (255 * percent) / 100)
  )
  const b = Math.min(255, Math.max(0, (num & 0x0000ff) + (255 * percent) / 100))

  return `#${(
    (1 << 24) +
    (Math.round(r) << 16) +
    (Math.round(g) << 8) +
    Math.round(b)
  )
    .toString(16)
    .slice(1)}`
}
